import { FC } from 'react';
import { useTranslation } from 'next-i18next';
import Icon from '@components/atoms/icon/icon';
import sanitizer from '@helpers/sanitizer';
import styles from './negotiation-modal-pricing-insight.module.scss';

type NegotiationModalPricingInsightProps = {
  shouldShow: boolean;
};

export const NegotiationModalPricingInsight: FC<NegotiationModalPricingInsightProps> = ({ shouldShow }) => {
  const { t } = useTranslation('common');
  const { t: tA11y } = useTranslation('a11y');

  if (!shouldShow) {
    return null;
  }

  return (
    <div
      data-cy="pricing-insight"
      className={styles.pricingInsight}
    >
      <Icon
        name="warning-24"
        className={styles.pricingInsight__icon}
        aria-label={tA11y('A11Y.ICON.WARNING')}
      />
      <div
        className={styles.pricingInsight__text}
        dangerouslySetInnerHTML={{ __html: sanitizer(t('NEGOTIATION_MODAL.OVERPRICED_WARNING')) }}
      />
    </div>
  );
};
